import(/* webpackMode: "eager" */ "/home/interim/frontend/app/solutions/corporate-partners/page.tsx");
